// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eiV8","questions":"styles_questions__2KYNK","footer":"styles_footer__3kkrV"};